import React, { Component } from "react";
import { connect } from "react-redux";

import { postServerDataWithTypes } from "../../../action/common_action";
import { ANY_ERROR } from "../../../action/user_action_types";
import { CAMPAIGN_DATA_OF_USER } from "../../../action/salesUser_action_types";

import Header from "../common/AuthHeader";
import SalesUserSideMenu from "../../../menu/SalesUserSideMenu";
import { history } from "../../../history/history";
import Pagination from "../../common/Pagination";
import { axiosInstnace, getLocalData } from "../../../util/util";
import { endPoints } from "../../../config";
import moment, { months } from "moment";
import StatusModel from "./statusupdate";
import { toast, ToastContainer } from "react-toastify";
import { CustomInvoice } from "./getCustomInvoicejsx";
import { ShowStations } from "../../campaign/ShowStations";
import Select from "@material-ui/core/Select";
import FormControl from "@material-ui/core/FormControl";
import ContactUsRemarks from "./viewContantDetails";


class ContactListComp extends Component {
  constructor(props) {
    super(props);
    //set initial state
    this.state = {
      salesUserInfo: getLocalData("salesUserInfo"),
      dsaConf: "",
      page: 1,
      limit: 10,
      totalRecords: 0,
      selectedCampaigns: [],
      selectedMonths: [],
      StatusModel: false,
      campaignsData: [],
      silver: {},
      gold: {},
      targetAmountAcheieved: 0,
      statusMessage: "",
      totalCamp: 0,
      grade: 0,
      customInVoiceNo: "",
      showCustomInvoiceNoPopup: false,
      showstationlist: false,
      currentStations: [],
      statusArray: [
        "Open",
        "Active",
        "Converted online",
        "Converted offline",
        "Duplicate",
        "Not reachable",
        "Unqualified",
        "Future Plan",
        "Audit in progress",
        "Audit Completed",
        "Not interested",
      ],
      contactDetail: [],
      openRemarksPopup: false
    };
  }

  hideshowstations = (e) => {
    this.setState({ showstationlist: !this.state.showstationlist });
  };

  //Get Campaign Data
  componentDidMount = () => {
    let { page } = this.state;
    this.getCampignsData(page);
  };

  //Fetching Campign Data from backend
  getCampignsData = async (page) => {
    debugger
    let { salesUserInfo } = this.state;
    let data = {
      email: salesUserInfo.email,
      //   invoicenotgenerated: true,
        // page
    };
    let data1 = await axiosInstnace.post(
      endPoints.getcampaignsbasedondsa,
      data
    );
    const contact = await axiosInstnace.get(endPoints.getContactUs, {
      params: {
        assignee: salesUserInfo.email,
        skip: (page- 1) * 10
      }
    });

    let contactleads = contact.data.data.data;
    if (contactleads) {
      for (let i = 0; i <= contactleads.length; i++) {
        if (contactleads[i] && contactleads[i].remarks) {
          contactleads[i].remarks = contactleads[i].remarks.reverse();
        }
      }
    }

    let config = await axiosInstnace.get(endPoints.getdsaconfig);
    config = config.data.data[0];
    let {
      result,
      grade,
      targetAmountAcheieved,
      silver,
      gold,
      totalCamp,
    } = data1.data.data;
    for (const camp of result) {
      camp.month = moment(parseInt(camp.createdAt)).get("M");
    }
    this.setState({
      campaignsData: contactleads,
      dsaConf: config,
      silver,
      gold,
      targetAmountAcheieved,
      totalCamp,
      totalRecords: contact.data.data.count,
      grade,
    });
  };

  //Go to Route bassed on path
  goToRoute = (name, data, path) => {
    history.push(path, { [name]: data });
  };
  handlestatuspage = () => {
    this.setState({
      StatusModel: !this.state.StatusModel,
    });
    window.location.reload(true);
  };

  getCustomInvoice = (e) => {
    this.setState({
      customInVoiceNo: e.target.value,
    });
  };

  selectCampaigns = (e, month) => {
    let { selectedCampaigns, selectedMonths } = this.state;
    if (
      (month === 3 && selectedMonths.includes(2)) ||
      (month === 2 && selectedMonths.includes(3))
    ) {
      toast.error(
        "Different Financial Year can't be clubbed for invoice generation",
        {
          position: toast.POSITION.TOP_CENTER,
          hideProgressBar: true,
          autoClose: false,
          toastId: "1",
        }
      );
      return;
    }
    let monthCamps = this.state.campaignsData.filter((e) => {
      return e.month === month;
    });
    monthCamps = monthCamps.map((e) => {
      return e._id;
    });
    if (e.currentTarget.checked) {
      selectedCampaigns = [...selectedCampaigns, ...monthCamps];
      selectedMonths.push(month);
      if (monthCamps.length > 1) {
        toast.success(
          "All the Campaigns in that month are added for invoice generation",
          {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 3000,
            hideProgressBar: true,
            toastId: "1",
          }
        );
      }
    } else {
      selectedCampaigns = selectedCampaigns.filter((el) => {
        return !monthCamps.includes(el);
      });
      selectedMonths = selectedMonths.filter((e) => e !== month);
      if (monthCamps.length > 1) {
        toast.success(
          "All the Campaigns in that month are removed for invoice generation",
          {
            position: toast.POSITION.TOP_CENTER,
            hideProgressBar: true,
            toastId: "1",
            autoClose: 3000,
          }
        );
      }
    }
    this.setState({
      selectedCampaigns,
      selectedMonths,
    });
  };
  closeCustomInvoicePopup = () => {
    this.setState({
      showCustomInvoiceNoPopup: false,
    });
  };
  openPopup = (event, contactDetails) => {

    if (
      contactDetails &&
      contactDetails.status &&
      contactDetails.status != "New" &&
      event.target.value === "New"
    ) {
      console.log("Error");
      toast.warn("Status cannot be set to New", {
        position: toast.POSITION.TOP_CENTER,
        hideProgressBar: false,
        toastId: "1",
      });
    } else {
      contactDetails.status = event.target.value;
      contactDetails.showAddRemarks = true;
      contactDetails.showListRemarks = true;
      this.setState({
        contactDetail: contactDetails,
        openRemarksPopup: true
      })
    }
  };

  openCloseRemarksPopup = (contactDetails) => {
    debugger
    console.log(contactDetails);
    contactDetails.showAddRemarks = false;
    contactDetails.showListRemarks = true;
    // handleContactDetail(contactDetails);
    this.setState({
      contactDetail: contactDetails,
      openRemarksPopup: true
    })
  };

  addNewRemarks = async (params) => {
    console.log(params);
    try {
      const data = await axiosInstnace.put(endPoints.addRemarksContactUs, params);
      const result = data.data.data.data;
      if (result && !toast.isActive("1")) {
        toast.success("Remarks Added Successfully", {
          position: toast.POSITION.TOP_CENTER,
          hideProgressBar: true,
          toastId: "1",
        });
        this.setState({
          openRemarksPopup: false
        })
        // getContactUs(0);
      }
    } catch (error) {
      console.log(error);
    }
  };
  toggleRemarksPopup = ()=>{
    this.setState({
      openRemarksPopup:!this.state.openRemarksPopup
    })
  }
  //Update Status for contact us entry
  updateStatus = async (params) => {
    console.log(params);
    try {
      const data = await axiosInstnace.put(endPoints.updateContactUs, params);
      const result = data.data.data.data;
      if (result && !toast.isActive("1")) {
        //   toast.success('Discount Added Sucessfully', {
        //     position:toast.POSITION.TOP_CENTER,
        //
        //     hideProgressBar:true,
        //     toastId:"1"
        //  });
        //  toggle();
        //  getContactUs(0);
      }
    } catch (error) {
      console.log(error);
    }
  };

  render() {
    let { campaignsData, totalRecords, page, limit } = this.state;
    let indexNum = (page - 1) * limit;
    return (
      <div className="main_wrapper">
        <SalesUserSideMenu {...this.props} />
        <div className="dashboard_right_wrapper">
          <div className="right_wrapper_inner">
            <Header
              silver={this.state.silver}
              gold={this.state.gold}
              targetAmountAcheieved={this.state.targetAmountAcheieved}
              totalCamp={this.state.totalCamp}
              grade={this.state.grade}
            />
            <div className="dash_content_wrapper">
              <div className="content_wrapper_inner">
                <ContactUsRemarks
                  isShowing={this.state.openRemarksPopup}
                  hide={this.toggleRemarksPopup}
                  contactDetail={this.state.contactDetail}
                  updateStatus={this.updateStatus}
                  addNewRemarks={this.addNewRemarks}
                />{" "}
                {campaignsData && campaignsData.length > 0 ? (
                  <div className={`camp_wrapper`}>
                    <div className="running_cap_head">
                      <h2 className="camp_head">Contact List</h2>
                    </div>
                    <div className="camp_listing_wrapper">
                      <table className="table table-striped">
                        <thead>
                          <tr>
                            <th>Date </th>
                            <th>Name </th>
                            <th>State</th>
                            <th>City</th>
                            <th>Message</th>
                            <th>Status </th>
                            <th>
                              Remarks <img />
                            </th>
                            <th>Campaign Id</th>
                            <th>Ro Id</th>
                            <th>Ro Amount</th>
                            <th>Ro Date</th>
                            <th>Last Update</th>
                            <th>Interactions</th>
                            <th>Company</th>
                            <th>Email</th>
                            <th>Mobile</th>
                          </tr>
                        </thead>
                        <tbody>
                          {campaignsData.map((r, i) => {
                            indexNum++;
                            return (
                              <tr key={i}>
                                <td className="contact_text">
                                  {" "}
                                  {moment(r.createdAt).format(
                                    "DD/MM/YYYY HH:mm:A"
                                  )}{" "}
                                </td>{" "}
                                <td className="contact_text"> {r.name} </td> <td className="contact_text"> {r.state} </td>{" "}
                                {/*<td>{r.district}</td>*/} <td> {r.city} </td>{" "}
                                <td className="contact_text"> {r.message} </td>{" "}
                                <td>
                                  {(this.state.statusArray.includes(r.status) ||
                                    r.status === "Follow Up") && (
                                      <select
                                        style={{ width: "150px" }}
                                        onChange={(event) => {
                                          debugger
                                          this.openPopup(event, r)}}
                                        value={
                                          r.status === "Follow Up"
                                            ? "Future Plan"
                                            : r.status
                                        }
                                        className={
                                          r.status == "New" || !r.status
                                            ? "status_select new"
                                            : "status_select ro_booked"
                                        }
                                      >
                                        {this.state.statusArray.map(
                                          (audioState, index) => (
                                            <option key={index}>
                                              {" "}
                                              {audioState}{" "}
                                            </option>
                                          )
                                        )}{" "}
                                      </select>
                                    )}
                                </td>
                                <td onClick={(e)=>{
                                        this.openCloseRemarksPopup(r)}}>
                                  <a>
                                    <span
                                      className="tooltip-reject fct-edit"
                                                                          >
                                      <img
                                        src="/assets/images/eye.png"
                                        className="viewUser"
                                      />
                                      <span> Remarks </span>{" "}
                                    </span>{" "}
                                  </a>{" "}
                                </td>
                                <td>{r.campaignId ? r.campaignId : "-"}</td>
                                <td>{r.roId ? r.roId : "-"}</td>
                                <td>{r.roAmount ? r.roAmount : "-"}</td>
                                <td>
                                  {r.roDate &&
                                    moment(r.roDate).format("DD/MM/YYYY")}
                                </td>
                                <td>
                                  {r.remarks.length > 0 &&
                                    moment(r.remarks[0].date).format(
                                      "DD/MM/YYYY hh:mm:A"
                                    )}{" "}
                                </td>{" "}
                                <td> {r.remarks ? r.remarks.length : "0"} </td>{" "}
                                <td> {r.company} </td> <td> {r.email} </td>{" "}
                                <td> {r.mobile} </td>{" "}
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                      <div className="paginationTable">
                        {totalRecords >= 10 && (
                          <Pagination
                            getAllData={this.getCampignsData}
                            totalRecords={totalRecords}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className={`bookcampaign`}>
                    <div>
                      <img src="../../assets/images/radio.png" />
                    </div>
                    <div className="book_camp_para">
                      <p>It seems like you don't have any contact lead's yet</p>
                    </div>
                    {/* <div className="book_camp_btn"><button onClick={() => {
                      window.location.href = '/package'
                    }}>BOOK CAMPAIGNS</button></div> */}
                  </div>
                )}
                {this.state.StatusModel && (
                  <StatusModel
                    hide={this.handlestatuspage}
                    isShowing={true}
                    message={this.state.statusMessage}
                  />
                )}
              </div>
            </div>
            {this.state.showCustomInvoiceNoPopup && (
              <CustomInvoice
                okButtonShow={true}
                closeAction={this.closeCustomInvoicePopup}
                okButtonText="Generate Invoice"
                okAction={this.generateInvoice}
                changeInvoiceNo={this.getCustomInvoice}
                msg="If you want to maintain and use existing series of invoice number(As a GST Compliance), please enter next usable invoice number of your existing series. If it's ok to assign autogenerated invoice number please leave it blank."
              />
            )}
          </div>
          <ToastContainer />
        </div>
        {this.state.showstationlist && (
          <ShowStations
            stations={this.state.currentStations}
            closeAction={this.hideshowstations}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    campaignsData: state.sales.get("campaignsDataOfUser"),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getSalesUserCampaign: (url, data, type) =>
      dispatch(postServerDataWithTypes(url, data, type)),
    showError: (error) =>
      dispatch({
        type: ANY_ERROR,
        payload: error,
      }),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(ContactListComp);



// WEBPACK FOOTER //
// ./web/components/salesUser/campaign/contactdetails.jsx